import axios, { Axios, AxiosRequestConfig } from 'axios'
import { getParams } from 'utils/helpers'

export const apiConfig = (config?: AxiosRequestConfig): Axios =>
	axios.create(config)

export const api = axios.create({
	baseURL: process.env.REACT_APP_BASE_API,
	headers: {
		'Content-type': 'application/json',
	},
})

api.interceptors.request.use(async (config: any) => {
	try {
		const { token } = await getParams()
		config.headers.Authorization = `Bearer ${token}`
	} catch (e) {
		console.log('Unable to Token', e)
	}
	return config
})

api.interceptors.response.use(
	response => {
		return response
	},
	async function (error) {
		const originalRequest = error.config
		if (
			error &&
			error.response &&
			error.response.status === 403 &&
			!originalRequest._retry
		) {
			try {
				originalRequest._retry = true
				const { token } = await getParams()
				axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
				return api(originalRequest)
			} catch (e) {
				console.log('Unable to refresh Token', e)
			}
		}
		return Promise.reject(error)
	},
)
